import React, { useState, useEffect } from 'react'

import { GoogleMap } from "../index"

const OVERVIEW_DIFFERENCE = 3
const OVERVIEW_MIN_ZOOM = 1
const OVERVIEW_MAX_ZOOM = 21

export const RoadLabel = ({roadLabel}) => {
  return roadLabel && (
    <div className="road-view">
      <span>Map View</span>
    </div>
  )
}

export const SatelliteLabel = ({satelliteLabel}) => {
  return satelliteLabel && (
    <div className="satellite-view">
      <span>Satellite View</span>
    </div>
  )
}

const MiniMap = ({ map }) => {

  const [miniMap, setMiniMap] = useState(null)
  const [roadLabel, setRoadLabel] = useState(false)
  const [satelliteLabel, setSatelliteLabel] = useState(true)

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max)
  }

  function changeMap() {
    if (map.getMapTypeId() === "roadmap") {
      map.setMapTypeId(window.google.maps.MapTypeId.HYBRID)
      miniMap.setMapTypeId(window.google.maps.MapTypeId.ROADMAP)
      setRoadLabel(true)
      setSatelliteLabel(false)
    } else {
      map.setMapTypeId(window.google.maps.MapTypeId.ROADMAP)
      miniMap.setMapTypeId(window.google.maps.MapTypeId.HYBRID)
      setRoadLabel(false)
      setSatelliteLabel(true)
    }
  }

  useEffect(() => {
    const miniMapZoomChange = () => {
      if (!miniMap) return
      miniMap.setCenter(map.getCenter())
      miniMap.setZoom(
        clamp(
          map.getZoom() - OVERVIEW_DIFFERENCE,
          OVERVIEW_MIN_ZOOM,
          OVERVIEW_MAX_ZOOM
        )
      )
    }

    map && map.addListener("bounds_changed", miniMapZoomChange)

    return () => {
      map && map.removeListener && map.removeListener("bounds_changed", miniMapZoomChange)
    }
  }, [ map, miniMap ])
  
  const mapOptions = {
    mapTypeId: window.google.maps.MapTypeId.HYBRID,
    disableDefaultUI: true,
    gestureHandling: "none",
    zoomControl: false,
    mapTypeControl: false,
    draggableCursor: 'pointer',
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  }
  const onMiniMapMount = (map) => {
    setMiniMap(map)
  }

  return (
    <div>
      <div className="mini-map-container" onClick={changeMap} data-test="minimap">
        <GoogleMap onMount={onMiniMapMount} options={mapOptions} containerHeight="90px" />
        <div className="minimap-overview-label" data-test="minimap-overview-label">
          <SatelliteLabel {...{satelliteLabel}} />
          <RoadLabel {...{roadLabel}} />
        </div>
      </div>
    </div>
  )
}

export default MiniMap
